export default __webpack_public_path__ + "static/extucnaci-0a06361c0f6091d34e1df30fe440d583.png";